<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar class="rounded-sm" :size="size" v-bind="attrs" v-on="on">
          <template v-if="imgUrl">
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <img v-else class="user-image-border" :src="imgUrl" />
          </template>
          <template v-else>
            <v-avatar class="rounded-sm" color="primary" :size="size">
              <v-icon :size="size / 2" dark> mdi-account-circle </v-icon>
            </v-avatar>
          </template>
        </v-avatar>
      </template>
      <span>{{ userName }}</span>
    </v-tooltip>
  </div>
</template>
<script>
import firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  name: 'BaseAppAvatar',
  props: {
    size: {
      default: () => null,
      type: String,
    },
    user: {
      default: () => null,
      type: String,
    },
  },
  data() {
    return {
      loading: true,
      imgUrl: null,
      mutableName: '',
    };
  },
  computed: {
    userName: {
      get() {
        return this.mutableName;
      },
      set(value) {
        this.mutableName = value;
      },
    },
  },
  methods: {
    async getImgUrl() {
      try {
        const document = await firebase
          .firestore()
          .collection('avatars')
          .doc(this.user)
          .get();

        const { url } = document.data();

        this.imgUrl = `${url}` || null;

        this.loading = false;
      } catch (error) {
        this.imgUrl = null;
        this.loading = false;
      }
    },
  },
  async mounted() {
    try {
      await this.getImgUrl();

      const { name } = (await (
        await firebase.firestore().collection('users').doc(this.user).get()
      ).data()) || { name: 'N/A' };

      this.userName = name;
    } catch (error) {
      this.userName = null;
      this.imgUrl = null;
      this.loading = false;
    }
  },
  watch: {
    user() {
      this.getImgUrl();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
</style>
